import * as UrlService from '../../shared/services/url.service';
import { Injectable } from '@angular/core';
import { FilterFieldDef } from '../models/filter';
import { SortItem } from '../models/sortItem';

@Injectable()
export class ArrayHelperService {
  constructor(
  ) { }

  public sortArray(sort: SortItem[], ary: any[]) {
    if (sort && ary)
      ary.sort((a, b) => {
        for (let i = 0; i < sort.length; i++) {
          var s = sort[i];
          let direction = s.sortDirection == 'desc' ? -1 : 1;
          let sortResult = sortItem(a[s.column], b[s.column], direction);

          if (sortResult != 0)
            return sortResult;
        }

        return 0;
      });
  }

  public fitlerArray(filterDef: any, filter: any, ary: any[]) : any[] {
    if (filter && filterDef) {
      let finalAry = [...ary];

      for (var key in filter) {
        let filterVal = filter[key];
        let def = <FilterFieldDef>filterDef[key];
        if (def && filterVal) {
          switch (def.type) {
            case 'number':
            case 'bool':
              finalAry = finalAry.filter((value) => value[key] == filterVal);
              break;
            case 'string':

              if (def.compareType == '=') {
                finalAry = finalAry.filter((value) => value[key] == filterVal);
              } else {
                finalAry = finalAry.filter((value) => {
                  if (!value[key] && !filterVal) {
                    return true;
                  } else if (!value[key] && filterVal) {
                    return false;
                  } else if (value[key] && !filterVal) {
                    return true;
                  } else {
                    return value[key].toLowerCase().includes(filterVal.toLowerCase());
                  }
                });
              }

              break;
            case 'date':
              let strDate = (filterVal instanceof Date
                ? filterVal.toISOString()
                : filterVal).split('T')[0];

              let filterDate = new Date(strDate);

              if (filterDate) {
                let fieldName = key.replace('_1', '').replace('_2', '');

                finalAry.filter((value) => {
                  if (!value)
                    return false;

                  if (!(value instanceof Date))
                    return false;

                  switch (def.compareType) {
                    case '>=':
                      return value[key] >= filterDate;
                    case '<=':
                      return value[key] <= filterDate;
                    case '>':
                      return value[key] > filterDate;
                    case '<':
                      return value[key] < filterDate;
                    default:
                      return value[key] == filterDate;
                  }
                });
              }
              
              break;
          }
        }
      }

      return finalAry;
    } else {
      return ary;
    }
  }

  public sortArrayString(ary: string[], direction: number) {
    ary.sort((a, b) => sortItem(a, b, direction));
  }
}

export function sortItem(a: any, b: any, direction: number): number {
  if (a === null && b === null) {
    return 0 * direction;
  } else if (a === null) {
    return 1 * direction;
  } else if (b === null) {
    return -1 * direction;
  } else {
    if (typeof a === "string" && typeof b === "string") {
      return a.localeCompare(b) * direction;
    } else if (typeof a === "number" && typeof b === "number") {
      return ((a > b) ? 1 : (a < b) ? -1 : 0) * direction;
    } else {
      return 0;
    }
  }
}
